import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const putMembro = async (
  token: string,
  cpf: string,
  nome: string,
  rg: string,
  orgao_expedidor: string,
  cargo: string,
  cep: string,
  estado: string,
  cidade: string,
  rua: string,
  bairro: string,
  numero: string,
  complemento?: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.put(
    `${API_URL}/membros/${cpf}`,
    {
      nome,
      rg,
      orgao_expedidor,
      cargo,
      cep,
      cidade,
      estado,
      bairro,
      rua,
      numero,
      complemento,
    },
    config
  );
  return response.data;
};
export default putMembro;
